import { useMemo } from 'react'
import { type AppSession, sessionOf } from '@/lib/auth/session-response'
import { useViewer } from '~/core/session/viewer'

export interface SessionHookResult {
  data: AppSession
  isPending: boolean
  error: unknown
  refetch: () => Promise<void>
}

/**
 * Who is signed in, for the Agent's readers.
 *
 * An adapter over the panel's viewer, not a read of its own: the module is
 * mounted under `SessionGate`, which has already answered the question and
 * turns a later 401 into the sign-in page.
 */
export function useSession(): SessionHookResult {
  const { data: me, isPending, error, refetch } = useViewer()
  const data = useMemo(() => sessionOf(me), [me])
  return useMemo(
    () => ({
      data,
      isPending,
      error,
      refetch: async () => {
        await refetch()
      },
    }),
    [data, isPending, error, refetch]
  )
}
